module.exports = __webpack_public_path__ + "static/media/Videos 2.c39a79f1.svg";